import { extendTheme } from "@chakra-ui/react";

const theme = extendTheme({
  colors: {
    brand: {
      black:     "#0D0D0D",
      charcoal:  "#1A1A1A",
      graphite:  "#1E1E1E",
      coral:     "#E05C3A",
      coralLight:"#E8765A",
      coralPale: "#F2C4B5",
      cream:     "#F5F0EB",
      sand:      "#E4DED2",
      sage:      "#595C4B",
      muted:     "#8A8A8A",
      line:      "#2E2E2E",
    },
  },
  fonts: {
    heading: "'Playfair Display', Georgia, serif",
    body:    "'DM Sans', 'Helvetica Neue', sans-serif",
  },
  styles: {
    global: {
      "html, body": {
        bg:             "#0D0D0D",
        color:          "#F5F0EB",
        scrollBehavior: "smooth",
        fontFamily:     "'DM Sans', sans-serif",
      },
      // Custom scrollbar
      "::-webkit-scrollbar":       { width: "6px", height: "6px" },
      "::-webkit-scrollbar-track": { bg: "#1A1A1A" },
      "::-webkit-scrollbar-thumb": { bg: "#2C2C2C", borderRadius: "3px" },
      "::-webkit-scrollbar-thumb:hover": { bg: "#E05C3A" },
    },
  },
  components: {
    Button: {
      variants: {
        coral: {
          bg: "#E05C3A", color: "#fff",
          fontFamily: "'DM Sans', sans-serif", fontWeight: "600",
          letterSpacing: "0.08em", textTransform: "uppercase",
          fontSize: "xs", px: 8, py: 6, borderRadius: "0",
          _hover: { bg: "#C94E2E", transform: "translateY(-1px)", boxShadow: "0 6px 20px rgba(224,92,58,0.35)" },
          _disabled: { bg: "#3a3a3a !important", color: "#555 !important", transform: "none !important", boxShadow: "none !important" },
          transition: "all 0.25s ease",
        },
        outlineLight: {
          bg: "transparent", color: "#F5F0EB",
          border: "1px solid rgba(245,240,235,0.3)",
          fontFamily: "'DM Sans', sans-serif", fontWeight: "600",
          letterSpacing: "0.08em", textTransform: "uppercase",
          fontSize: "xs", px: 8, py: 6, borderRadius: "0",
          _hover: { borderColor: "#E05C3A", color: "#E05C3A", transform: "translateY(-1px)", bg: "transparent" },
          transition: "all 0.25s ease",
        },
        ghostCoral: {
          bg: "transparent", color: "#E05C3A",
          border: "1px solid #E05C3A",
          fontFamily: "'DM Sans', sans-serif", fontWeight: "600",
          letterSpacing: "0.08em", textTransform: "uppercase",
          fontSize: "xs", px: 8, py: 6, borderRadius: "0",
          _hover: { bg: "#E05C3A", color: "#fff", transform: "translateY(-1px)" },
          transition: "all 0.25s ease",
        },
        ghost: {
          bg: "transparent",
          _hover: { bg: "rgba(224,92,58,0.08)" },
        },
      },
    },
    Input: {
      variants: {
        dark: {
          field: {
            bg: "#2C2C2C", border: "1px solid rgba(46,46,46,0.9)",
            borderRadius: "0", color: "#F5F0EB",
            _placeholder: { color: "rgba(245,240,235,0.25)" },
            _focus:  { borderColor: "#E05C3A", boxShadow: "0 0 0 1px #E05C3A" },
            _hover:  { borderColor: "rgba(224,92,58,0.35)" },
            _disabled: { opacity: 0.5, cursor: "not-allowed" },
          },
        },
      },
    },
    Select: {
      variants: {
        dark: {
          field: {
            bg: "#2C2C2C", border: "1px solid rgba(46,46,46,0.9)",
            borderRadius: "0", color: "#F5F0EB",
            _focus: { borderColor: "#E05C3A", boxShadow: "0 0 0 1px #E05C3A" },
            "> option": { bg: "#2C2C2C", color: "#F5F0EB" },
          },
          icon: { color: "#E05C3A" },
        },
      },
    },
    Textarea: {
      variants: {
        dark: {
          bg: "#2C2C2C", border: "1px solid rgba(46,46,46,0.9)",
          borderRadius: "0", color: "#F5F0EB",
          _placeholder: { color: "rgba(245,240,235,0.25)" },
          _focus: { borderColor: "#E05C3A", boxShadow: "0 0 0 1px #E05C3A" },
          _hover: { borderColor: "rgba(224,92,58,0.35)" },
        },
      },
    },
    Checkbox: {
      baseStyle: {
        control: {
          borderRadius: "0",
          borderColor: "rgba(46,46,46,0.9)",
          _checked: { bg: "#E05C3A", borderColor: "#E05C3A" },
          _focus: { boxShadow: "0 0 0 1px #E05C3A" },
        },
      },
    },
    Modal: {
      baseStyle: {
        dialog:  { bg: "#1A1A1A", borderRadius: "0" },
        overlay: { bg: "rgba(0,0,0,0.7)" },
      },
    },
    Tooltip: {
      baseStyle: {
        bg: "#2C2C2C", color: "#F5F0EB", fontSize: "xs",
        borderRadius: "0", border: "1px solid rgba(46,46,46,0.8)",
      },
    },
    Alert: {
      baseStyle: { container: { borderRadius: "0" } },
    },
  },
});

export default theme;
